import React, { lazy } from 'react';

import DashboardLayout from '../layout/dashboard';
import Loadable from '../components/Loadable';

const Dashboard = Loadable(lazy(() => import('../pages/dashboard')));

const ArticleCategoriesPage = Loadable(
  lazy(() => import('../pages/articleCategories')),
);

const ArticlesPage = Loadable(lazy(() => import('../pages/articles')));
const UpsertArticlePage = Loadable(
  lazy(() => import('../pages/articles/upsert')),
);

const Menu = Loadable(lazy(() => import('../pages/menu')));

const Roles = Loadable(lazy(() => import('../pages/roles')));
const Users = Loadable(lazy(() => import('../pages/users')));

const InformationPages = Loadable(
  lazy(() => import('../pages/informationPages')),
);

const Texts = Loadable(lazy(() => import('../pages/texts')));

const BenefitsPage = Loadable(lazy(() => import('../pages/benefits')));
const StatementsPage = Loadable(lazy(() => import('../pages/statements')));
const SolutionsPage = Loadable(lazy(() => import('../pages/solutions')));

const UpsertSolutionsPage = Loadable(
  lazy(() => import('../pages/solutions/upsert')),
);
const ServicesPage = Loadable(lazy(() => import('../pages/services')));

const CallbackOrdersPage = Loadable(
  lazy(() => import('../pages/callback-orders')),
);

const PagesPage = Loadable(lazy(() => import('../pages/pages')));

const Vacancies = Loadable(lazy(() => import('../pages/vacancies')));
const UpsertVacancies = Loadable(
  lazy(() => import('../pages/vacancies/upsert')),
);

const HomePageSectionsPage = Loadable(
  lazy(() => import('../pages/homePageSections')),
);

const PrivacyPolicyPage = Loadable(
  lazy(() => import('../pages/privacyPolicy')),
);

const SponsorsPolicyPage = Loadable(lazy(() => import('../pages/sponsors')));
const TermsConditionsPage = Loadable(
  lazy(() => import('../pages/termsConditions')),
);

const protectedRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'dashboard',
          element: <Dashboard />,
        },
        {
          path: 'article-categories',
          element: <ArticleCategoriesPage />,
        },
        {
          path: 'articles',
          element: <ArticlesPage />,
        },
        {
          path: 'articles/upsert',
          element: <UpsertArticlePage />,
        },
        {
          path: 'articles/upsert/:identity',
          element: <UpsertArticlePage />,
        },
        {
          path: 'menu',
          element: <Menu />,
        },
        {
          path: 'roles',
          element: <Roles />,
        },
        {
          path: 'users',
          element: <Users />,
        },
        {
          path: 'information-pages',
          element: <InformationPages />,
        },
        {
          path: 'texts',
          element: <Texts />,
        },
        {
          path: 'benefits',
          element: <BenefitsPage />,
        },
        {
          path: 'statements',
          element: <StatementsPage />,
        },
        {
          path: 'solutions',
          element: <SolutionsPage />,
        },
        {
          path: 'solutions/upsert',
          element: <UpsertSolutionsPage />,
        },
        {
          path: 'solutions/upsert/:identity',
          element: <UpsertSolutionsPage />,
        },
        {
          path: 'services',
          element: <ServicesPage />,
        },
        {
          path: 'callback-orders',
          element: <CallbackOrdersPage />,
        },
        {
          path: 'pages',
          element: <PagesPage />,
        },
        {
          path: 'vacancies',
          element: <Vacancies />,
        },
        {
          path: 'vacancies/upsert',
          element: <UpsertVacancies />,
        },
        {
          path: 'vacancies/upsert/:identity',
          element: <UpsertVacancies />,
        },
        {
          path: 'home-page-sections',
          element: <HomePageSectionsPage />,
        },
        {
          path: 'privacy-policy',
          element: <PrivacyPolicyPage />,
        },
        {
          path: 'sponsors',
          element: <SponsorsPolicyPage />,
        },
        {
          path: 'terms-conditions',
          element: <TermsConditionsPage />,
        },
      ],
    },
  ],
};

export default protectedRoutes;
